import { render, staticRenderFns } from "./consent.vue?vue&type=template&id=19d7768a&scoped=true"
import script from "./consent.vue?vue&type=script&lang=js"
export * from "./consent.vue?vue&type=script&lang=js"
import style0 from "./consent.vue?vue&type=style&index=0&id=19d7768a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d7768a",
  null
  
)

export default component.exports